import { useState } from 'react'

import Grid from '@material-ui/core/Grid'
import Dialog from "@base/Dialog";
import Typography from '@material-ui/core/Typography';

export const ArmazenarObjetoPostalDialog = (props) => {
  const [open, ] = useState(props.open ?? false);

  return (
    <Dialog
      maxWidth={props.maxWidth ?? "lg"}
      fullWidth={true}
      closeDialog={props.close}
      openDialog={open}
      title='ATENÇÃO!'
    >
        <Grid item container spacing={4} style={{backgroundColor: 'rgba(255, 0, 0, 0.8)', height: '300px', textAlign:'center'}}>

          <Grid item sm={12} lg={12}>

              <Typography variant="h4" style={{color: '#fff', lineHeight: '5rem'}}>{props.erro.replace(": ","")}</Typography>
              {props.statusMensagem && <>
              <Typography variant="h4" style={{color: '#fff'}}>Envie-o para a:</Typography>
              <Typography variant="h1" style={{color: '#fff', fontWeight: 'bold'}}>{props.statusMensagem}</Typography></> }

          </Grid>

        </Grid>

    </Dialog>
  );
}

export default ArmazenarObjetoPostalDialog;
